import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Avatar,
  Box,
  ButtonBase,
  Typography,
  useMediaQuery,
} from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';

// assets
import { IconMenu2 } from '@tabler/icons-react';
import Ticker from 'react-ticker';
import { useLocation } from 'react-router';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery('(max-width: 1024px)');
  const location = useLocation();
  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto',
          },
        }}
      >
        <Box
          component='span'
          sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}
        >
          <LogoSection />
        </Box>
        {isMobileScreen && (
          <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
            <Avatar
              variant='rounded'
              sx={{
                ...theme.typography.commonAvatar,
                ...theme.typography.mediumAvatar,
                transition: 'all .2s ease-in-out',
                background: theme.palette.secondary.light,
                color: theme.palette.secondary.dark,
                '&:hover': {
                  background: theme.palette.secondary.dark,
                  color: theme.palette.secondary.light,
                },
              }}
              onClick={handleLeftDrawerToggle}
              color='inherit'
            >
              <IconMenu2 stroke={1.5} size='1.3rem' />
            </Avatar>
          </ButtonBase>
        )}
      </Box>

      {/* header search */}
      {/* <SearchSection /> */}
      <Box sx={{ flexGrow: 1, paddingX: '24px' }}>
        <Ticker key={location.pathname} mode={'await'}>
          {({ index }) => (
            <>
              <Typography
                sx={{
                  fontSize: { xs: '4.5vw', sm: '28px' },
                  fontWeight: 500,
                  color: theme.palette.secondary.main,
                }}
              >
                {'All Departments Please Add Your Pending Sub Actions'}
              </Typography>
            </>
          )}
        </Ticker>
      </Box>

      {/* <Box sx={{ flexGrow: 1, padding: '10px' }} /> */}

      {/* notification & profile */}
      <NotificationSection />
      <ProfileSection />
      <Box
        sx={{
          width: 180,
          paddingX: 4,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto',
          },
        }}
      >
        <Box component='span' sx={{ display: { xs: 'none', md: 'block' } }}>
          <LogoSection right={true} />
        </Box>
      </Box>
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
};

export default Header;
